import { Directive } from '@angular/core';

@Directive({
  selector: '[cardFooter]',
  standalone: true
})
export class CardFooterDirective {
}
